module.exports = __webpack_public_path__ + "img/search-result.a48a759b.webp";